import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//Import Select Component

export default {
  DeleteModal:function(self){
    return(
      <Modal isOpen={self.state.ActiveDelete.modal} toggle={self.toogleDeleteImageModal} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.toogleDeleteImageModal}>{'Delete asset image'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div>
            {"Are you sure want to delete this image from your asset?"}
          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.toogleDeleteImageModal}>Cancel</Button>
          <Button color="danger" onClick={()=>self.__DeleteImage__(self)}>Delete</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },

}



// WEBPACK FOOTER //
// ./src/App/asset/photo/helper/modal.js